
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequirea579"];
var parcelRegister = parcelRequire.register;
parcelRegister("b9Bdz", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $81ed67a82fa8c591$export$2cd8252107eb640b; });
// ====================================================================================
// eyeAble.module
// ====================================================================================
const $81ed67a82fa8c591$export$2cd8252107eb640b = ()=>{
    let attempts = 0;
    const maxAttempts = 30;
    const setupContrastButton = ()=>{
        const contrastButton = document.querySelector(".as-eyeable__contrast");
        if (!contrastButton) return;
        contrastButton.addEventListener("click", ()=>{
            contrastButton.classList.toggle("enabled");
            if (contrastButton.classList.contains("enabled")) {
                EyeAbleAPI.enableContrast("rgb(255,255,255)", "rgb(0,0,0)");
                document.body.classList.add("as-ea-contrast");
            } else {
                EyeAbleAPI.disableContrast();
                document.body.classList.remove("as-ea-contrast");
            }
        });
    };
    const whenComplete = ()=>{
        if (++attempts > maxAttempts) return;
        if (document.readyState === "complete") {
            if (typeof EyeAbleAPI === "undefined") {
                console.error("EyeAbleAPI is not available");
                return;
            }
            setupContrastButton();
            let colorMode = EyeAbleAPI.getColorMode();
            if (colorMode === "Contrast") document.body.classList.add("as-ea-contrast");
        } else setTimeout(whenComplete, 400);
    };
    whenComplete();
};

});


//# sourceMappingURL=eyeAble.cfbc344b.js.map
